const PurchaseSupplierSkusHeader = [
  {
    group: "Pedido",
    columns: [
      {
        name: "",
        id: "pedido-supplier-cod",
        show: false,
      },
      {
        name: "",
        id: "pedido-id",
        show: false,
      },
      {
        name: "",
        id: "pedido-color",
        show: false,
      },

      {
        name: "Status da Entrega",
        id: "pedido-status",
        show: true,
      },
      {
        name: "Centro",
        id: "pedido-centro",
        show: true,
      },
      {
        name: "Pedido",
        id: "pedido-numero",
        show: true,
      },

      {
        name: "Código Fornecedor",
        id: "pedido-codigo-fornecedor",
        show: true,
      },
      {
        name: "Código",
        id: "pedido-codigo",
        show: true,
      },
      {
        name: "Nome Produto",
        id: "pedido-nome-produto",
        show: true,
      },
    ],
  },
  {
    group: "Quantidade",
    columns: [
      {
        name: "Total",
        id: "quantidade-total",
        show: true,
      },
      {
        name: "Entregue",
        id: "quantidade-entregue",
        show: true,
      },
      {
        name: "Pendente",
        id: "quantidade-pendente",
        show: true,
      },
      {
        name: "Agendada",
        id: "quantidade-agendada",
        show: true,
      },
      {
        name: "Pendente Agendamento",
        id: "quantidade-pedente-agendada",
        show: true,
      },
      {
        name: "Agendar",
        id: "quantidade-agendar",
        show: true,
      },
    ],
  },
  {
    group: "Data",
    columns: [
      {
        name: "Prevista",
        id: "data-prevista",
        show: true,
      },
    ],
  },
];

export default PurchaseSupplierSkusHeader;
